import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Outbound } from 'ts/flight/interfaces/FlightDetailsResponse';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { isTT } from 'constants/generic';

interface TicketBaggagePopupProps {
  outbond: Outbound;
}

const TicketBaggagePopup: FC<TicketBaggagePopupProps> = ({ outbond }) => {
  const { t } = useTranslation();

  const isRedHandbag =
    !outbond.listOfFlyBaggagePrice ||
    !outbond.listOfFlyBaggagePrice?.[0] ||
    outbond.listOfFlyBaggagePrice?.[0]?.maxWeightHandbag === 0;
  const isRedTrolley =
    !outbond.listOfFlyBaggagePrice ||
    !outbond.listOfFlyBaggagePrice?.[0] ||
    outbond.listOfFlyBaggagePrice?.[0]?.maxWeightTrolley === 0;
  const isGreenTotal =
    outbond.listOfFlyBaggagePrice &&
    (outbond.listOfFlyBaggagePrice?.[0]?.maxTotalWeight > 0 ||
      outbond.listOfFlyBaggagePrice?.[0]?.pieces > 0);

  return (
    <div className="ticket-baggage-popup">
      {outbond.listOfFlyBaggagePrice?.[0]?.maxWeightHandbag !== -1 && (
        <div>
          {isRedHandbag ? (
            <span className="color-danger">{t('flight.handbag_excluded')}</span>
          ) : (
            <span className="text-success">
              {t('flight.handbag_included')} {outbond.listOfFlyBaggagePrice?.[0]?.maxWeightHandbag}
              {t('kg')}
            </span>
          )}
        </div>
      )}
      {outbond.listOfFlyBaggagePrice?.[0]?.maxWeightTrolley !== -1 && (
        <div>
          {isRedTrolley ? (
            <span className="color-danger">{t('flight.trolley_excluded')}</span>
          ) : (
            <span className="text-success">
              {t('flight.trolley_included')}
              {outbond.listOfFlyBaggagePrice?.[0]?.maxWeightTrolley}
              {t('kg')}
            </span>
          )}
        </div>
      )}
      {outbond.listOfFlyBaggagePrice?.[0]?.maxTotalWeight !== -1 && (
        <div>
          {isGreenTotal ? (
            <span className="text-success">
              {t('flight.bag_included')}
              {!!outbond.listOfFlyBaggagePrice?.[0]?.maxTotalWeight && (
                <span>
                  {outbond.listOfFlyBaggagePrice?.[0]?.maxTotalWeight}
                  {t('kg')}
                </span>
              )}
            </span>
          ) : (
            <span className="color-danger">{t('flight.bag_excluded')}</span>
          )}
        </div>
      )}
      {outbond.airline.key && !isTT && (
        <Fragment>
          <div className="divider-sm mb-10 mt-10"></div>
          <span className="text-sm">
            {t('flight.all_baggage_information_on_the_airline_website')}:{' '}
          </span>
          <a className="link" href={outbond.airline.key} target="_blank" rel="noreferrer">
            {outbond.airline.desc}
          </a>
        </Fragment>
      )}
    </div>
  );
};

export default withErrorBoundary(TicketBaggagePopup, 'TicketBaggagePopup');
